import {useSelector} from 'react-redux';

/**
 * The current employee's email.
 * @returns {string|undefined} The current employee's email.
 */
export const useEmployeeEmail = () => useSelector(state => state.user.employee.email);
